export default __webpack_public_path__ + "static/media/panner.1e4fe0d1.png";